<template>
  <div class="importStaffStepTwo">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm {{ dataImportCurrent.length }} nhóm công việc<br /></h1>
      <p class="text-primary font-size-16">{{ fileName }}</p>
      <div class="float-right">
        <router-link
          class="f12 font-medium btn btn-outline-secondary mr-1"
          :to="`/group-calendar-afs-import`"
          >Chọn lại
        </router-link>
      </div>
    </div>
    <!-- End Breadcrumb Area -->
    <div
      v-if="countItemSuccess.length > 0"
      class="alert alert-success alert-dismissible fade show"
      role="alert"
    >
      <strong>Thành công: {{ countItemSuccess }}</strong
      ><br />
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="alert alert-warning alert-dismissible fade show" role="alert">
      <strong>Lỗi: {{ countItemErr }}</strong>
      <br />
      Vui lòng kiểm tra bản ghi lỗi được bôi màu đỏ và thực hiện import lại những bản ghi lỗi
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="card pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="box-view">
          <div class="box-table table-responsive">
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-center" width="50">STT</th>
                  <th scope="col" class="text-center">Tên nhóm công việc</th>
                  <th scope="col" class="text-center">Mã nhóm công việc</th>
                  <th scope="col" class="text-center">Dịch vụ áp dụng</th>
                  <th scope="col" class="text-center">Mô tả</th>
                  <th scope="col" class="text-center">Thời gian hoàn thành</th>
                  <th scope="col" class="text-center">Đơn vị thời gian</th>
                  <th scope="col" class="text-center">Lỗi</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in dataImportCurrent" :key="index">
                <tr
                  :class="[
                    item.descriptionValidate !== ''
                      ? 'table-row bg-danger text-light'
                      : 'table-row',
                  ]"
                >
                  <td align="center">{{ index + 1 }}</td>
                  <td align="center">
                    <b>{{ item.groupName }}</b>
                  </td>
                  <td align="center">{{ item.groupCode }}</td>
                  <td align="center">{{ item.service }}</td>
                  <td align="center">{{ item.note }}</td>
                  <td align="center">{{ item.finishTime }}</td>
                  <td align="center">{{ item.finishTimeType }}</td>
                  <td align="center">{{ item.descriptionValidate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        dataImportCurrent: [],
        dataErrCurrent: [],
        countItemErr: null,
        countItemSuccess: null,
      }
    },

    created() {
      this.dataImportCurrent = [...this.dataImport]
      this.dataErrCurrent = [...this.dataErr]

      if (this.dataErrCurrent && this.dataErrCurrent.length > 0) {
        this.dataImportCurrent.map((elmDataImport, indexIP) => {
          this.dataErrCurrent.map((elmErr, indexER) => {
            if (elmErr.lineError === indexIP + 3) {
              elmDataImport.descriptionValidate = elmErr.message
            }
          })
        })
        this.countItemErr = this.dataImportCurrent.filter((e, i) => e.descriptionValidate).length
        this.countItemSuccess = this.dataImportCurrent.length - this.countItemErr
      }
    },

    computed: {
      ...mapGetters({
        dataImport: 'staff/getDataCacheTableRow',
        dataErr: 'staff/getDataCacheErrTableRow',
        fileName: 'staff/getDataFileNameExcel',
      }),
    },

    methods: {},
  }
</script>

<style scoped></style>
>
